// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261639/js/" + chunkId + "." + {"44":"4d0aafdb","225":"072ceb35","481":"bb109a3f","486":"b249bdb8","770":"bba081d7"}[chunkId] + ".0.918249257656181.chunk.js";
};